import React from 'react';
import { Beer, Users, Music, Utensils } from 'lucide-react';
import { businessData } from '../data/mock';
import './About.css';

const features = [
  {
    icon: Beer,
    title: 'Cerveza Artesanal',
    description: 'Amplia variedad de cervezas artesanales locales cuidadosamente seleccionadas.'
  },
  {
    icon: Users,
    title: 'Ambiente Cálido',
    description: 'Un espacio acogedor donde pasar buenos momentos con amigos o familia.'
  },
  {
    icon: Music,
    title: 'Buena Música',
    description: 'Selección musical que acompaña perfectamente cada momento del día.'
  },
  {
    icon: Utensils,
    title: 'Picadas Argentinas',
    description: 'Deliciosas picadas clásicas para compartir con tu cerveza favorita.'
  }
];

const About = () => {
  return (
    <section id="nosotros" className="about section">
      <div className="about__container container">
        <div className="about__header">
          <h2 className="section-title">Un rincón para disfrutar</h2>
          <p className="section-subtitle">
            Un bar para quienes disfrutan de la buena cerveza artesanal, 
            la comida rica y los momentos compartidos.
          </p>
        </div>
        
        <div className="about__grid">
          {features.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <div 
                key={index} 
                className="about__card card"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="icon-wrapper">
                  <IconComponent size={24} />
                </div>
                <h3 className="about__card-title">{feature.title}</h3>
                <p className="about__card-description">{feature.description}</p>
              </div>
            );
          })}
        </div>
        
        <div className="about__services">
          <h3 className="about__services-title">Nuestros servicios</h3>
          <div className="about__services-list">
            {businessData.services.map((service, index) => (
              <span key={index} className="about__service-badge">
                {service}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
